// Curated 5-star Trustpilot reviews shown by TestimonialsCarousel on the checkout
// pages (order-details, payment-details) and the signup page.
//
// One list per clinical vertical. `name` is the reviewer's display name exactly as
// published on Trustpilot and `description` is the review text verbatim (only
// trailing whitespace trimmed). Do not tidy either; the Trustpilot review id and
// date on each entry point back at the source review.
//
// Performance anxiety (pac/paf) and generalized anxiety (gac/gaf) share the
// beta-blocker list for the same reason Go's orderTypeVertical (app/domain_types.go)
// treats them as one anxiety vertical. Anything that is not an insomnia consultation
// type, including a missing or malformed value, falls back to that list because it
// is what every page showed before the content became vertical-aware.

import { isConsultationTypeInsomnia } from "~/shared/utils/sharedUtils";

export const ANXIETY_TESTIMONIALS = [
  {
    // Trustpilot review 6a985e40f4dbb054df3a765a, 2026-09-02
    name: "Matthew Neupert",
    description:
      "Used it for the first time before officiating a wedding ceremony for my good friends. Made a huge difference in terms of the symptoms I normally display with public speaking. Highly recommended!",
  },
  {
    // Trustpilot review 6a5016cc2f89424ec6f2d468, 2026-07-09
    name: "JB",
    description:
      "I walked into a series of high-stakes interviews prepared at a level most candidates never reach, but Kick beta blockers were that extra something that helped me get out of my own way so that preparation could show up fully. The confidence the panel saw wasn't manufactured — it was real and earned, and I got the job offer.   Thank you, Kick!",
  },
  {
    // Trustpilot review 6a7327af2660a150cbadf396, 2026-08-05
    name: "Alan E",
    description:
      "I have a daily meeting where I have to speak to various financial markets topics.  Taking a dose one hour before the meeting has helped me reduce my anxiety and to think more clearly to communicate more effectively.",
  },
  {
    // Trustpilot review 6a6ca45febb11198c845b2f5, 2026-07-31
    name: "Carissa Wolfe",
    description:
      "The online process for Kick was easy and efficient! The propranolol really helped me during anxiety inducing exams for school.",
  },
  {
    // Trustpilot review 6a79ff0021bd81b231155cc5, 2026-08-10
    name: "Tina Bagwell",
    description:
      "The beta blockers worked well for me during critical meetings.",
  },
  // Original 2023 quotes, replaced in September 2026. Kept for an easy swap back;
  // re-pin the name list in testimonials.test.js if any are restored.
  // {
  //   // Trustpilot review 64de5bedb9c779b91228cc1a, 2023-08-17 (wording edited; the
  //   // source reads "Kick Health is a lifesaver! Their online service made ...")
  //   name: "Robert D.",
  //   description:
  //     "Kick is a lifesaver! Their service made getting propranolol for my anxiety a breeze. Quick, caring, and affordable. What stood out to me was their genuine concern for my well-being. Highly recommend!",
  // },
  // {
  //   // Trustpilot review 64bd761ec19ce9b3145ba9b5, 2023-07-23
  //   name: "Shane Curtis",
  //   description:
  //     "I am shocked how well this worked for me. I normally have intense anxiety before public speaking engagements, of which I have done many, and this made me feel so much more relaxed. I wish I had discovered this sooner… 10/10 would recommend trying.",
  // },
  // {
  //   // Trustpilot review 650e7daaf962871dab2d8665, 2023-09-23
  //   name: "Elijah Luke",
  //   description:
  //     "My career would be over if not for Kick.com and Beta blockers ....i have suffered from crippling anxiety for many years that has caused me loss in opportunities and relationships but thanks to Kick and Beta blockers I am finally gaining my life back....Finding Kick health.com has been a God send 😍",
  // },
];

export const SLEEP_TESTIMONIALS = [
  {
    // Trustpilot review 6a56c902e3b74e92bd5a415a, 2026-07-15
    name: "Julie Howard",
    description:
      "I was so impressed by how quickly my sleep problems were solved. I took the test at 4am defeated and by 10am my prescriptions were ready. I went through the 2 week process and chose the medication that worked best for me. I had questions and the doctor quickly answered them. What a great concept!!",
  },
  {
    // Trustpilot review 6985f0d4af96a8e6820a8dd0, 2026-02-06
    name: "Casey W",
    description:
      "10 Stars! This is a great way to try different medications to find the one that works best. No other program would give this option. Some meds worked but had side effects I didn't love. The doctor considered my feedback, answered all my questions and prescribed different meds based on my feedback until I found the right one. Highly recommend.",
  },
  // {
  //   // Trustpilot review 6a8b9664893828424309304f, 2026-08-24
  //   name: "Barbara Simmons",
  //   description:
  //     "Great team to work with. I am finally at about 6 hours of sleep at night. I am feeling so much better!",
  // },
  {
    // Trustpilot review 68d717f84b362380e5bf942d, 2025-09-27
    name: "Mackenzie Brennan",
    description:
      "Poor sleep has been SUCH a problem for me and I tried everything before finding you guys. The telehealth option made things so much less overwhelming. Finally found a solution and I'm incredibly relieved and grateful-- thank you!!",
  },
  {
    // Trustpilot review 68b76620799fab17f5ac2335, 2025-09-02
    name: "Anna V Murray",
    description:
      "Kick Health is an excellent and trustworthy company. They have a strong commitment to customer service and it shows. Communication is excellent! It was easy to go through the process and find the right prescription for me to help with my chronic insomnia. I highly recommend this company.",
  },
];

// testimonialsForConsultationType picks the list for a consultation type as it appears
// in the route (pac, paf, gac, gaf, inc, inf) or in its legacy long form, in any
// casing. This is the single place the vertical is decided: callers pass the raw route
// value and never choose a list themselves.
export function testimonialsForConsultationType(consultationType) {
  const normalized =
    typeof consultationType === "string" ? consultationType.toLowerCase() : "";
  return isConsultationTypeInsomnia(normalized)
    ? SLEEP_TESTIMONIALS
    : ANXIETY_TESTIMONIALS;
}
